import { Component, OnInit } from "@angular/core";
import { DeliveryComponent } from "./../delivery/delivery.component";

declare var $: any;
declare var myFlickity: any;
import { QuotingContextData } from "../model/quoting-context.model";
import { Router, ActivatedRoute } from "@angular/router";
import { DataService } from "../shared/services/data.service";
import {
  PlanSelection,
  RateTablePackage,
  Network,
  Plan,
  PlanRates,
  EmployeeContribution,
} from "../model/planSelection.model";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { NgxSpinnerService } from "ngx-spinner";
import { RateTableInfo } from "../model/rateTableInformation.model";
import { RateTableRequest } from "../model/rateTableRequest.model";
import { StateId } from "../model/enums/stateCode.enum";
import { BenefitType } from "../model/enums/benefit-type.enum";
import { AuthorizationService } from "../authorization/authoriation.service";
import { ContributionComponent } from "./../contribution/contribution.component";
import {
  ContributionType,
  EmployeContributionType,
  PayPeriod,
} from "../model/enums/contribution-type.enum";
import { PsContributionComponent } from "../ps-contribution/ps-contribution.component";


@Component({
  selector: "app-plans",
  templateUrl: "./plans.component.html",
  styleUrls: ["./plans.component.css"],
})
export class PlansComponent implements OnInit {
  requestData: QuotingContextData;
  webPackageDisplayed: any = [];
  flickityObj: any;
  allPlans: boolean = true;
  allPackagePlans: boolean = false;
  selectedPackageIds: number[] = [];
  selectedPackage: PlanSelection = new PlanSelection();
  rateTableInfo: RateTableInfo = new RateTableInfo();
  rateTablePackage: any = Array<Array<any>>();
  benefitTypes: BenefitType[] = [];
  networkData: any = {};
  planData: any = {};
  planRate: any = {};
  rateTableRequest: RateTableRequest = new RateTableRequest();
  selectedWebPackageDisplayed: any = [];
  isMenuOpen: boolean = false;
  screenWidth: number;
  Id: number = 0;
  brokerState = localStorage.getItem("broker_state");
  isPlanSelected: boolean = true;
  retainAllPlans: boolean = true;
  totalPlansSelected: number = 0;
  isGenerateDialogOpen = false;
  allPlansDisplayed: any;
  selectedWebPackage: any = [];
  isSamePackagePlanSelected: boolean = true;
  constructor(
    private dialog: MatDialog,
    public router: Router,
    private dataService: DataService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public authService: AuthorizationService
  ) {
    this.Id = Number(this.dataService.getValueFromRoute(this.route, "Id"));
    this.screenWidth = window.innerWidth;

    window.onresize = () => {
      // set screenWidth on screen size change
      this.screenWidth = window.innerWidth;
    };
  }
  ngOnInit() {
    this.allPlans = true;
    this.getRatetable();
    this.dataService.activateNetworkNav.next(true);
  }
  getRatetable(): any {
    this.dataService.getRateTableDatabyId(this.Id).subscribe((result) => {
      if (result) {
        this.rateTableRequest = result;
        this.rateTableInfo = JSON.parse(this.rateTableRequest.RequestJson);
        //initialize employee contribution
        this.rateTableInfo.EmployeeContribution.ContributionAmountTypeId=ContributionType.NoContribution;;
        this.rateTableInfo.EmployeeContribution.DependentContributionAmount=0;
        this.rateTableInfo.EmployeeContribution.DependentContributionPercent=0;
        this.rateTableInfo.EmployeeContribution.EmployeeContributionAmount=0;
        this.rateTableInfo.EmployeeContribution.EmployeeContributionPercent=0;
        this.rateTableInfo.EmployeeContribution.EmployerSelectedPlan='';
        this.rateTableInfo.EmployeeContribution.EmployerSelectedPlanId=0;
        this.rateTableInfo.EmployeeContribution.PayPeriod=PayPeriod.Monthly;
        this.GetPlans();
      }
    });
  }

  GetPlans() {
    this.spinner.show();
    this.requestData = new QuotingContextData();
    this.requestData.NetworkIds = this.rateTableInfo.Carrier.networks;
    this.requestData.SicCode = this.rateTableInfo.Group.SicCode;
    this.requestData.CarrierId = Number(
      this.rateTableInfo.Carrier.nqsCarrierId
    );
    (this.requestData.CarrierName = this.rateTableInfo.Carrier.CarrierName),
      (this.requestData.EffectiveDate = this.rateTableInfo.Group.EffectiveDate);
    this.requestData.CoverageTypeId = 1;
    this.requestData.ERCountyCode = this.rateTableInfo.Group.CountyCode;
    this.requestData.ERStateId =this.getStateId(this.rateTableInfo.Group.StateCode);
    this.requestData.StateCode =  this.rateTableInfo.Group.StateCode;
    this.requestData.ERZipCode = this.rateTableInfo.Group.ZipCode;
    this.requestData.UserRole = this.authService.userRole;
    this.dataService.getPackagePlan(this.requestData).subscribe((result) => {
      if (result) {
        let nqsPackages: any = [];
        nqsPackages = result;
        let existingNewtorkIds = [];
        nqsPackages.forEach((pack) => {
          let p = new RateTablePackage();
          p.IsSelectBoxActive = false;
          p.PlanSelected = 0;
          p.CoverageTypeId = pack.coverageTypeId;
          p.MaxPlansAllowed = pack.maxPlansAllowed;
          p.MinPlanAllowed = pack.minPlanAllowed;
          p.Networks = pack.networks;
          p.OrionPackageId = pack.orionPackageId;
          p.PackageId = pack.packageId;
          p.PackageName = pack.packageName;
          p.Networks = [];
          pack.networks.forEach((networkDetails) => {
            let n = new Network();
            if (existingNewtorkIds.indexOf(networkDetails.networkId) === -1) {
              existingNewtorkIds.push(networkDetails.networkId);
              n.ShowNetworkInAllPlans = true;
            }
            n.IsSelectBoxActive = false;
            n.NetworkId = networkDetails.networkId;
            n.NetworkName = networkDetails.networkName;
            n.NetworkOrder = networkDetails.networkOrder;
            n.PackageId = pack.packageId;
            n.BenefitTypeId = networkDetails.benefitTypeId;
            n.Plans = [];
            networkDetails.plans.forEach((planDetails) => {
              let pl = new Plan();
              pl.IsSelectBoxActive = false;
              pl.PlanId = planDetails.planId;
              pl.PlanName = planDetails.planName;
              pl.PlanRates = new Array<PlanRates>();
              pl.AreaName = planDetails.areaName;
              planDetails.planRates.forEach((planRates) => {
                let prs = new PlanRates();
                let pr = [];
                planRates.rates.forEach((planRate) => {
                  pr.push(planRate);
                });
                prs.Rates = pr;
                pl.PlanRates.push(prs);
              });
              n.Plans.push(pl);
            });
            n.Plans.sort((planA: Plan, planB: Plan) => {
              return (
                parseFloat(planA.PlanRates[0].Rates[0]) -
                parseFloat(planB.PlanRates[0].Rates[0])
              );
            });
            p.Networks.push(n);
          });
          p.Networks.sort((netA: Network, netB: Network) => {
            return netA.NetworkOrder - netB.NetworkOrder;
          });
          this.webPackageDisplayed.push(p);
        });
        this.webPackageDisplayed = this.webPackageDisplayed.sort(
          (packA, packB) => {
            return (
              packA.Networks[0].NetworkOrder - packB.Networks[0].NetworkOrder
            );
          }
        );
        this.allPlansDisplayed = this.webPackageDisplayed
          .map((pack) => pack.Networks)
          .flat(2)
          .filter((net) => net.ShowNetworkInAllPlans)
          .sort((netA, netB) => {
            if (netA.NetworkOrder === netB.NetworkOrder) {
              return netA.NetworkId - netB.NetworkId;
            }
            return netA.NetworkOrder - netB.NetworkOrder;
          });

        this.initializeBenefitTypes();
        this.webPackageDisplayed.forEach((packageDetails) => {
          packageDetails.IsSelectBoxActive = false;
          packageDetails.PlanSelected = 0;
          packageDetails.Networks.forEach((networkDetails) => {
            networkDetails.IsSelectBoxActive = false;
            networkDetails.Plans.forEach((planDetails) => {
              planDetails.IsSelectBoxActive = false;
            });
          });
        });

        //Bind data in edit mode
        this.selectedWebPackageDisplayed = this.rateTableInfo.PlanSelection;
        if (this.rateTableInfo.IsAllPackagePlans) {
          this.allPackagePlans = true;
          this.retainAllPlans = false;
          this.allPlans = false;
        } else {
          this.allPackagePlans = false;
          this.retainAllPlans = true;
          this.allPlans = true;
        }
        if (
          this.selectedWebPackageDisplayed !== undefined &&
          this.selectedWebPackageDisplayed[0] &&
          this.selectedWebPackageDisplayed[0].PackageId !== undefined
        ) {
          this.bindDataEditMode();
        }

        if (this.allPackagePlans) {
          this.initializeFlickity();
        }
        this.spinner.hide();
      }
    });
  }

  initializeBenefitTypes() {
    let networks = this.webPackageDisplayed
      .map((pack) => pack.Networks)
      .flat(2);
    networks.forEach((network) => {
      if (
        this.benefitTypes.filter((bt) => bt == network.BenefitTypeId).length ==
        0
      ) {
        this.benefitTypes.push(network.BenefitTypeId);
      }
    });
  }

  getTotalPlansSelected() {
    let totalPlans = 0;
    this.webPackageDisplayed.forEach((pack) => {
      pack.Networks.forEach((net) => {
        net.Plans.forEach((plan) => {
          if (plan.IsSelectBoxActive) {
            totalPlans++;
          }
        });
      });
    });
    this.totalPlansSelected = totalPlans;
    return totalPlans;
  }

  unCheckPlansByPackages() {
    let networks = this.webPackageDisplayed
      .map((pack) => pack.Networks)
      .flat(2);
    if (
      networks.filter((net) => net.IsSelectBoxActive).length > 0 &&
      this.allPlans
    ) {
      this.retainAllPlans = true;
      return true;
    } else {
      this.retainAllPlans = false;
      return false;
    }
  }

  initializeFlickity() {
    setTimeout(() => {
      this.flickityObj = $(".package-carousel").flickity({
        cellAlign: "left",
        prevNextButtons: false,
        dragThreshold: 20,
        setGallerySize: true,
        freeScroll: true,
      });
    }, 0);

    setTimeout(function () {
      $(".package-carousel").flickity().focus();
    }, 10);
  }

  openGenerateDialog(): void {
    if (
      !(this.webPackageDisplayed.filter((p) => p.PlanSelected > 0).length > 0)
    ) {
      this.isPlanSelected = false;
    } else {
      this.getSelectedPackage();
      this.rateTableRequest.RequestJson = JSON.stringify(this.rateTableInfo);
      this.dataService
        .saveRateTableInfo(this.rateTableRequest)
        .subscribe((result) => {
          if (result) {
            if (this.isGenerateDialogOpen) {
              return;
            }

            this.isGenerateDialogOpen = true;
            this.dialog
              .open(DeliveryComponent, {
                disableClose: true,
                panelClass: "generate-panel",
                data: {
                  Id: this.Id,
                  rateTableInfo: this.rateTableInfo,
                },
              })
              .afterClosed()
              .subscribe((result) => {
                this.isGenerateDialogOpen = false;
              });
          }
        });
    }
  }
  getSelectedPackage(): any {
    let i = 0;
    let packageCount = 0;
    this.rateTablePackage = [];
    this.webPackageDisplayed.forEach((packageDetails) => {
      if (packageDetails.IsSelectBoxActive == true) {
        this.rateTablePackage.push({});
        this.rateTablePackage[packageCount].PackageName =
          packageDetails.PackageName;
        this.rateTablePackage[packageCount].PackageId =
          packageDetails.PackageId;
        this.rateTablePackage[packageCount].CoverageTypeId =
          packageDetails.CoverageTypeId;
        this.rateTablePackage[packageCount].OrionPackageId =
          packageDetails.OrionPackageId;
        this.rateTablePackage[packageCount].IsSelectBoxActive =
          packageDetails.IsSelectBoxActive;
        this.rateTablePackage[packageCount].Networks = [];
        packageDetails.Networks.forEach((networkDetails) => {
          if (networkDetails.IsSelectBoxActive == true) {
            this.planData = networkDetails.Plans;
            this.rateTablePackage[packageCount].Networks.push(
              Object.assign({}, networkDetails)
            );
            this.rateTablePackage[packageCount].Networks[i].Plans = [];
            this.planData.forEach((planDetails) => {
              if (planDetails.IsSelectBoxActive) {
                this.rateTablePackage[packageCount].Networks[i].Plans.push(
                  planDetails
                );
              }
            });
            i++;
          }
        });
        packageCount++;
        i = 0;
      }
    });
    this.rateTableInfo.PlanSelection = this.rateTablePackage;
    this.rateTableInfo.IsAllPackagePlans = this.allPackagePlans;
    console.log(this.rateTableInfo);
  }

  checkIfPlansSelected() {
    if (
      !(this.webPackageDisplayed.filter((p) => p.PlanSelected > 0).length > 0)
    ) {
      this.isPlanSelected = true;
      this.selectUnselectPackage();
    } else {
      this.isPlanSelected = false;
    }
  }
  showAllPlans() {
    if (!this.retainAllPlans) this.unCheckPlansByPackages();
    this.allPlans = true;
    this.allPackagePlans = false;
    this.checkIfPlansSelected();
    this.sortPackagesByNetworkOrder();
  }
  showAllPackagePlans() {
    if (this.retainAllPlans) this.unCheckPlansByPackages();
    this.allPlans = false;
    this.allPackagePlans = true;
    this.initializeFlickity();
    this.checkIfPlansSelected();
  }
  sortPackagesByNetworkOrder() {
    this.webPackageDisplayed.sort((packA, packB) => {
      return packA.Networks[0].NetworkOrder - packB.Networks[0].NetworkOrder;
    });
  }

  selectOrUnselectPackage(wabPackage: any): any {
    if (this.retainAllPlans) {
      this.selectUnselectPackage();
      this.retainAllPlans = false;
    }
    if (wabPackage) {
      if (wabPackage.IsSelectBoxActive) {
        wabPackage.IsSelectBoxActive = !wabPackage.IsSelectBoxActive;
        this.isPlanSelected = true;
      } else {
        this.selectUnselectPackage();
        wabPackage.IsSelectBoxActive = !wabPackage.IsSelectBoxActive;
      }
      wabPackage.Networks.forEach((networkDetails) => {
        networkDetails.IsSelectBoxActive = wabPackage.IsSelectBoxActive;
        networkDetails.Plans.forEach((planDetails) => {
          planDetails.IsSelectBoxActive = wabPackage.IsSelectBoxActive;
        });
      });
      this.totalPlanSelected(wabPackage);
    }
    setTimeout(function () {
      $(".package-carousel").flickity("resize");
    }, 150);
    if (
      !(this.webPackageDisplayed.filter((p) => p.PlanSelected > 0).length > 0)
    ) {
      this.isPlanSelected = true;
    } else {
      this.isPlanSelected = false;
    }
  }
  getPackageById(packageId) {
    return this.webPackageDisplayed.filter(
      (pack) => pack.PackageId === packageId
    )[0];
  }
  selectOrUnselectNetwork(
    networkDetail: any,
    wabPackage: any,
    isMultiplePackageSelect: boolean = true
  ): any {
    //let isNetworkSelected = 0
    if (!wabPackage) {
      wabPackage = this.getPackageById(networkDetail.PackageId);
    }
    this.selectUnslectRetainedValues();
    let isAllNetworkSelected = 0;
    if (networkDetail) {
      if (!isMultiplePackageSelect) {
        //Un-select the old package
        this.webPackageDisplayed.forEach((packageDetails) => {
          if (
            packageDetails.IsSelectBoxActive == true &&
            packageDetails.PackageId != wabPackage.PackageId
          ) {
            packageDetails.IsSelectBoxActive = false;
            packageDetails.Networks.forEach((networkDetails) => {
              networkDetails.IsSelectBoxActive = false;
              networkDetails.Plans.forEach((planDetails) => {
                planDetails.IsSelectBoxActive = false;
              });
            });
          }
        });
      }
      networkDetail.IsSelectBoxActive = !networkDetail.IsSelectBoxActive;
      let networkStatus = networkDetail.IsSelectBoxActive;

      if (!wabPackage.IsSelectBoxActive) {
        wabPackage.IsSelectBoxActive = !wabPackage.IsSelectBoxActive;
      }
      if (wabPackage.isSelectBoxActive) {
        this.isPlanSelected = true;
      }

      networkDetail.Plans.forEach((planDetails) => {
        planDetails.IsSelectBoxActive = networkStatus;
      });

      //Set package to unselect if all networks are unselected
      this.webPackageDisplayed.forEach((packageDetails) => {
        packageDetails.Networks.forEach((networkDetails) => {
          if (networkDetails.IsSelectBoxActive == true) {
            isAllNetworkSelected = 1;
          }
        });
      });
      if (isAllNetworkSelected == 0) {
        wabPackage.IsSelectBoxActive = false;
      }
      this.totalPlanSelected(wabPackage);
      if (
        !(this.webPackageDisplayed.filter((p) => p.PlanSelected > 0).length > 0)
      ) {
        this.isPlanSelected = true;
      } else {
        this.isPlanSelected = false;
      }
    }
  }
  selectUnslectRetainedValues() {
    if (this.allPlans && !this.retainAllPlans) {
      this.selectUnselectPackage();
      this.retainAllPlans = true;
    } else if (this.allPackagePlans && this.retainAllPlans) {
      this.selectUnselectPackage();
      this.retainAllPlans = false;
    }
  }
  selectOrUnselectPlans(
    plan: any,
    networkDetail: any,
    wabPackage: any,
    isMultiplePackageSelect: boolean = true
  ): any {
    if (!wabPackage) {
      wabPackage = this.getPackageById(networkDetail.PackageId);
    }
    this.selectUnslectRetainedValues();
    let isPlanSelected = 0;
    let isNetworkSelected = 0;
    if (plan) {
      if (!isMultiplePackageSelect) {
        //Un-select the old package
        this.webPackageDisplayed.forEach((packageDetails) => {
          if (
            packageDetails.IsSelectBoxActive == true &&
            packageDetails.PackageId != wabPackage.PackageId
          ) {
            packageDetails.IsSelectBoxActive = false;
            packageDetails.Networks.forEach((networkDetails) => {
              networkDetails.IsSelectBoxActive = false;
              networkDetails.Plans.forEach((planDetails) => {
                planDetails.IsSelectBoxActive = false;
              });
            });
          }
        });
      }
      plan.IsSelectBoxActive = !plan.IsSelectBoxActive;
      if (!wabPackage.IsSelectBoxActive) {
        wabPackage.IsSelectBoxActive = !wabPackage.IsSelectBoxActive;
      }
      if (!networkDetail.IsSelectBoxActive) {
        networkDetail.IsSelectBoxActive = !networkDetail.IsSelectBoxActive;
      }
      if (!plan.IsSelectBoxActive) {
        networkDetail.Plans.forEach((planDetails) => {
          if (planDetails.IsSelectBoxActive == true) {
            isPlanSelected = 1;
          }
        });
        if (isPlanSelected == 1) {
          networkDetail.IsSelectBoxActive = true;
        } else {
          networkDetail.IsSelectBoxActive = false;
        }
      }
      //Set package to unselec if all networks are unselected
      this.webPackageDisplayed.forEach((packageDetails) => {
        packageDetails.Networks.forEach((networkDetails) => {
          if (networkDetails.IsSelectBoxActive == true) {
            isNetworkSelected = 1;
          }
        });
      });
      if (isNetworkSelected == 0) {
        wabPackage.IsSelectBoxActive = false;
      }
      this.totalPlanSelected(wabPackage);
    }
    if (
      !(this.webPackageDisplayed.filter((p) => p.PlanSelected > 0).length > 0)
    ) {
      this.isPlanSelected = true;
    } else {
      this.isPlanSelected = false;
    }
  }
  addNoScrollBackground() {
    this.isMenuOpen = true;
  }

  removeNoScrollBackground() {
    this.isMenuOpen = false;
  }
  selectUnselectPackage() {
    this.webPackageDisplayed.forEach((sp) => {
      sp.PlanSelected = 0;
    });
    this.webPackageDisplayed.forEach((packageDetails) => {
      packageDetails.IsSelectBoxActive = false;
      packageDetails.Networks.forEach((networkDetails) => {
        networkDetails.IsSelectBoxActive = false;
        networkDetails.Plans.forEach((planDetails) => {
          planDetails.IsSelectBoxActive = false;
        });
      });
    });
  }

  totalPlanSelected(planPackage: any) {
    planPackage.PlanSelected = 0;
    planPackage.Networks.forEach((networkDetails) => {
      networkDetails.Plans.forEach((planDetails) => {
        if (planDetails.IsSelectBoxActive == true) {
          planPackage.PlanSelected++;
          this.isPlanSelected = false;
        }
      });
    });
  }

  bindDataEditMode() {
    let selectedNetworkCount = 0;
    this.webPackageDisplayed.forEach((sp) => {
      sp.PlanSelected = 0;
    });
    let packageCount = 0;
    this.webPackageDisplayed.forEach((packageDetails, index) => {
      if (
        this.selectedWebPackageDisplayed
          .map((p) => p.PackageId)
          .indexOf(packageDetails.PackageId) > -1
      ) {
        packageDetails.IsSelectBoxActive = true;
      }
      selectedNetworkCount = 0;
      if (
        this.selectedWebPackageDisplayed[packageCount] &&
        this.selectedWebPackageDisplayed[packageCount].PackageId ===
          packageDetails.PackageId
      ) {
        packageDetails.Networks.forEach((networkDetails) => {
          selectedNetworkCount = 0;
          this.selectedWebPackageDisplayed[packageCount].Networks.forEach(
            (selectedNetwork) => {
              if (networkDetails.NetworkId == selectedNetwork.NetworkId) {
                networkDetails.IsSelectBoxActive = true;
                networkDetails.Plans.forEach((planDetails) => {
                  if (
                    this.selectedWebPackageDisplayed[packageCount].Networks[
                      selectedNetworkCount
                    ]
                  ) {
                    this.selectedWebPackageDisplayed[packageCount].Networks[
                      selectedNetworkCount
                    ].Plans.forEach((selectedPlan) => {
                      if (planDetails.PlanId == selectedPlan.PlanId) {
                        planDetails.IsSelectBoxActive = true;
                        packageDetails.PlanSelected++;
                      }
                    });
                  }
                });
              }
              selectedNetworkCount++;
            }
          );
        });
        packageCount++;
      }
    });

    if (
      !(this.webPackageDisplayed.filter((p) => p.PlanSelected > 0).length > 0)
    ) {
      this.isPlanSelected = true;
    } else {
      this.isPlanSelected = false;
    }
  }
  openContributionDialoge(): void {
    if (
      !(this.webPackageDisplayed.filter((p) => p.PlanSelected > 0).length > 0)
    ) {
      this.isPlanSelected = false;
    } else {
      this.getSelectedPackage();
      this.checkSamePackagePlanSelected();
      const contribution = this.dialog.open(PsContributionComponent, {
        disableClose: true,
        panelClass: "generate-panel",
        data: {
          Id: this.Id,
          rateTableInfo: this.rateTableInfo,
          isSamePackagePlanSelected: this.isSamePackagePlanSelected,
        },
      });
      contribution.afterClosed().subscribe((result) => {
        this.rateTableInfo = result.rateTableInfo;
      });
    }
  }
  private checkSamePackagePlanSelected(): void {
    let packageId: any = [];
    this.selectedWebPackage = this.webPackageDisplayed.filter(
      (p) => p.PlanSelected > 0
    );
    this.selectedWebPackage.forEach((pack) => {
      packageId.push(pack.Networks[0].PackageId);
    });
    const distinctPackageId = packageId.filter(
      (n, i) => packageId.indexOf(n) === i
    );
    if (distinctPackageId.length === 1) {
      this.isSamePackagePlanSelected = true;
    } else {
      this.isSamePackagePlanSelected = false;
    }
  }
   // Method to get the StateId corresponding to a given state abbreviation
  // If not found in the enum, return the brokerState value (which was the existing implementation)
  getStateId(stateAbbreviation: string): StateId {
    const stateId = StateId[stateAbbreviation as keyof typeof StateId];
    if (stateId !== undefined) {
        return stateId;
    } else {
        return  Number(this.brokerState);
    }
}
}
